import { useMutation } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

interface DownloadBulkCertificatesPayload {
  vesselId: string
  fileNames: string[]
}

interface DownloadBulkCertificatesResponse {
  signedUrl: string
}

const getFilenamesAsEncodedQueryString = (fileNames: string[]): string =>
  fileNames.map((fileName) => `name=${encodeURIComponent(fileName)}`).join('&')

export function useDownloadBulkCertificates() {
  const fetchRequest = useFetch<string | DownloadBulkCertificatesResponse>()

  return useMutation({
    mutationFn: async ({
      vesselId,
      fileNames,
    }: DownloadBulkCertificatesPayload): Promise<DownloadBulkCertificatesResponse> => {
      const params = getFilenamesAsEncodedQueryString(fileNames)

      const result = await fetchRequest(
        `${apiBase()}/vessels/${vesselId}/documents/archive?${params}`,
      )

      // API returns JSON.stringify'd response with text/plain content-type
      if (typeof result === 'string') {
        return JSON.parse(result) as DownloadBulkCertificatesResponse
      }
      return result
    },
  })
}
